import React, { useState } from 'react';
import { css } from 'aphrodite/no-important';
import { LinkButtonDataProps } from '../../../utils';
import { AdditionalStyleSheet } from '../../../../../components.utils';
import { MenuIcon } from '../../primaryHeader/menu/icons/MenuIcon';
import { MenuLinks } from './MenuLinks';
import { NavigationLink } from '../../primaryHeader/PrimaryHeader';
import { MenuLinkDataProps } from '../../primaryHeader/menu/links/MenuSubLink';

export interface MenuDataProps {
  links: MenuLinkDataProps[];
  buttons?: Array<LinkButtonDataProps>;
  editions: NavigationLink[] | null;
  editionEndpoint: string;
  additionalStyle?: AdditionalStyleSheet;
}

export const Menu: React.FunctionComponent<MenuDataProps> = props => {
  const [state, setState] = useState({
    isMenuOpen: false,
    currentOpenLink: -1,
  });
  const { isMenuOpen, currentOpenLink } = state;

  const clickOnMenuIcon = () => {
    setState({
      isMenuOpen: !isMenuOpen,
      currentOpenLink: isMenuOpen ? currentOpenLink : -1,
    });
  };

  const clickOnLinkDropDown = (index: number) => {
    setState({
      isMenuOpen,
      currentOpenLink: currentOpenLink === index ? -1 : index,
    });
  };

  const { links, editions, editionEndpoint, buttons, additionalStyle } = props;
  return (
    <div className={css(additionalStyle && additionalStyle.style)}>
      <MenuIcon isMenuOpen={isMenuOpen} onClick={clickOnMenuIcon} />
      <MenuLinks menuLinks={links} buttons={buttons} editions={editions} isMenuOpen={isMenuOpen} onClick={clickOnLinkDropDown} currentOpenLink={currentOpenLink} editionEndpoint={editionEndpoint} />
    </div>
  );
};
